export default __webpack_public_path__ + "static/media/programming.e82f4066.png";